import type { ProjectResponseAuthContext } from './projectResponseAuthContext';
import type { ProjectResponseBasicInfo } from './projectResponseBasicInfo';
import type { ProjectResponseFileInfo } from './projectResponseFileInfo';
import type { ProjectResponseMetaInfo } from './projectResponseMetaInfo';
import type { ProjectResponseStatsInfo } from './projectResponseStatsInfo';
import type { ProjectResponseUserInfo } from './projectResponseUserInfo';
import type { ProjectResponseUserInteraction } from './projectResponseUserInteraction';

/**
 * 구조화된 단일 프로젝트 응답 데이터
 */
export interface ProjectResponse {
  /** 인증 컨텍스트 정보 */
  authContext?: ProjectResponseAuthContext;
  /** 프로젝트 기본 정보 */
  basicInfo?: ProjectResponseBasicInfo;
  /** 프로젝트 파일 정보 */
  fileInfo?: ProjectResponseFileInfo;
  /** 프로젝트 메타 정보 */
  metaInfo?: ProjectResponseMetaInfo;
  /** 프로젝트 통계 정보 */
  statsInfo?: ProjectResponseStatsInfo;
  /** 간략한 사용자 정보 */
  userInfo?: ProjectResponseUserInfo;
  /** 현재 사용자와 프로젝트 간의 상호작용 정보 */
  userInteraction?: ProjectResponseUserInteraction;
}
